import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {HttpClient} from '@angular/common/http';
import {BaseClientComponent} from '../base-client.component';
import {environment} from '../../../environments/environment';
import {Router} from '@angular/router';
import {SelectItem} from 'primeng/api';
import * as _ from 'lodash';
import {RoleService} from '../../services/role.service';
import {Company} from '../../models/company';
import {User} from '../../models/user';
import {firstValueFrom} from 'rxjs';

@Component({
  selector: 'app-impersonate-user',
  templateUrl: './impersonate-user.component.html',
  styleUrls: ['./impersonate-user.component.scss'],
  host: {class: 'sym-page'}
})
export class ImpersonateUserComponent extends BaseClientComponent implements OnInit {

  subscriptions: any;
  listClients: Company[];
  usersList: User[] = [];
  loading = true;
  selectedClient: any;
  listClientsForClientDropDown: SelectItem[] = [];
  canImpersonate = false;
  canImpersonateChecked = false;

  usersTableColumns = [
    {field: 'email', header: 'Email', sortDisabled: false, class: ''},
    {field: 'name', header: 'Name', sortDisabled: false, class: ''},
    {field: 'role', header: 'Role', sortDisabled: true, class: ''},
    {field: 'lastLogin', header: 'Last login', sortDisabled: true, class: ''},
    {field: 'impersonateUser', header: 'Impersonate User', sortDisabled: true, class: ''},
  ];

  constructor(public authenticationService: AuthenticationService,
              protected utilsService: UtilsService,
              private roleService: RoleService,
              protected http: HttpClient,
              protected router: Router) {
    super();
  }

  ngOnInit() {
    this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.checkCanImpersonate();
      return;
    });
  }

  checkCanImpersonate() {
    const url = environment.baseUrlWs + '/user/can-impersonate';
    this.http.get<{ allowed: boolean }>(url).subscribe(
      response => {
        this.canImpersonate = response.allowed;
        this.canImpersonateChecked = true;
        if (this.canImpersonate) {
          this.loadListClients();
        }
      },
      () => {
        this.canImpersonate = false;
        this.canImpersonateChecked = true;
      }
    );
  }

  loadListClients() {
    const companyUrl = environment.baseUrlWs + '/api/clients-dropdown';
    this.utilsService.cacheablePromise(() => firstValueFrom(this.http.get<any>(companyUrl)),
      'companiesDropDown__' + this.authenticationService.userImpersonatedId, true)
      .then(
        response => {
          this.listClients = response['member'].filter(client => client.isActive);
          _.forEach(this.listClients, (client: Company) => {
            if (client.uniqid !== 'admin') {
              this.listClientsForClientDropDown.push({
                label: client.name,
                value: client.uniqid,
              });
            }
          });
          this.listClientsForClientDropDown = this.listClientsForClientDropDown.sort((a, b) => a.label.localeCompare(b.label));
          this.loading = false;
          this.utilsService.unlockUi();
        }, () => {
          return;
        }
      );
  }

  loadClientsUsers() {
    this.usersList = [];
    if (!this.selectedClient) {
      return;
    }
    this.loading = true;
    const loadFilteredUsersListUrl = environment.baseUrlWs + '/api/users?company.uniqid=' + this.selectedClient;
    this.loadUsersList(loadFilteredUsersListUrl);
  }

  loadUsersList(loadFilteredUsersListUrl: string) {
    this.loading = true;
    this.utilsService.lockUi();
    const response = this.utilsService.cacheableObservable(
      () => this.http.get<any>(loadFilteredUsersListUrl),
      null,
      true, 'Users List updated'
    ).subscribe(
      res => {
        this.usersList = res.filter(user => user.isActive);
        this.utilsService.unlockUi();
        this.loading = false;
      }
    );
    this.subscriptions.push(response);
  }

  parseToStringRoles(user: User): string {
    if (!user || !user.roleGroups) {
      return;
    }
    return this.roleService.parseToString(user.roleGroups);
  }

  impersonateUser(email: string) {
    this.authenticationService.impersonateUserUsingWs$(email).subscribe({
      next: () => {
        const companyUniqId = this.authenticationService.getUserCurrent().company.uniqid;
        if ('admin' === companyUniqId) {
          location.assign('/#/mckay/' + companyUniqId);
        } else {
          location.assign('/#/client/' + companyUniqId);
        }
      },
      error: () => {
      }
    });
  }
}
